const Upchart = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="48"
        height="48"
        rx="4"
        fill="#17C289"
        fill-opacity="0.11"
      ></rect>
      <path
        d="M17.25 29.3125C17.25 29.6289 17.4961 29.875 17.8125 29.875H31.875C32.4727 29.875 33 30.4023 33 31C33 31.6328 32.4727 32.125 31.875 32.125H17.8125C16.2305 32.125 15 30.8945 15 29.3125V17.5C15 16.9023 15.4922 16.375 16.125 16.375C16.7227 16.375 17.25 16.9023 17.25 17.5V29.3125ZM30.4336 25.0586L29.2734 23.9336L26.4609 26.7461C26.0391 27.2031 25.3008 27.2031 24.8789 26.7461L22.3125 24.1797L20.2734 26.1836C19.8516 26.6406 19.1133 26.6406 18.6914 26.1836C18.2344 25.7617 18.2344 25.0234 18.6914 24.6016L21.5039 21.7891C21.9258 21.332 22.6641 21.332 23.0859 21.7891L25.6875 24.3555L27.6914 22.3516L26.5312 21.1914C26.0039 20.6641 26.3906 19.75 27.1289 19.75H31.0312C31.4883 19.75 31.875 20.1367 31.875 20.5938V24.4961C31.875 25.2344 30.9609 25.6211 30.4336 25.0586Z"
        fill="#17C289"
      ></path>
    </svg>
  );
};
export default Upchart;
